import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { GenericDatasetFilter } from "../../../zodios/apiDefinitions/api/datasets/genericQuery";
import { AD_STATUSES } from "../../../components/core/blocks/AdPlan/constants";

type AdOptionsParams = {
  categoryId?: number | string;
  enabled?: boolean;
  limit?: number;
};

type AdOption = { id: number; name: string };

export const useAdOptions = ({ categoryId, enabled = true, limit = 10000 }: AdOptionsParams = {}) => {
  const filters: GenericDatasetFilter[] = [
    // Exclude archived ads
    { id: "ad_status", op: "ne", value: AD_STATUSES.GV_ADV_ARCHIVED.value },
    ...(categoryId != null ? [{ id: "category_id", op: "eq", value: categoryId } as const] : []),
  ];

  const query = useQuery({
    queryKey: ["adOptions", categoryId ?? null, limit],
    enabled,
    queryFn: async () =>
      await apiClient.genericDatasetsQuery({
        from: "api_gvadvertisementch",
        select: [
          { field: "id", alias: "ad_id" },
          { field: "name", alias: "ad_name" },
        ],
        filters,
        limit,
      }),
  });

  const options: AdOption[] = useMemo(
    () =>
      query.data?.data.map((row) => ({
        id: row.ad_id as number,
        name: row.ad_name as string,
      })) ?? [],
    [query.data],
  );

  return { ...query, options };
};
